import { FileIcon } from "../../icons/file";
import React from "react";

const FileSymbol = (props: { template: "blue" | "gray"}) => {

    return(
        <div className={`gridCenter fileSymbol ${props.template}`}>
            <FileIcon width={14} height={14} />
        </div>
    )
}

export default FileSymbol;
